<template>
  <v-col
    :class="{
      'get-lower': !$vuetify.breakpoint.mdAndUp,
      'pa-0': true,
      fullScreen: true,
      fullScreenMobile: this.$vuetify.breakpoint.mdAndDown
    }"
    cols="12"
  >
    <DialogForMassOperators
      :dialog.sync="dialogMove"
      :loading.sync="loading"
      :head-text="$t('document-templates.choose-library')"
      :confirm-button="{
        text: $t('document-templates.move'),
        icon: 'mdi-arrow-expand-right'
      }"
      :selected="selected"
      v-on:update:selected="updateSelected"
      :destinations="libraries"
      destination-label="document-templates.library"
      dispatch="documentTemplateStore/massMove"
      :isWillRemove="true"
      :on-success="updateList"
      permission="document_template.update"
    ></DialogForMassOperators>
    <DialogForMassOperators
      :dialog.sync="dialogCopy"
      :loading.sync="loading"
      :head-text="$t('document-templates.choose-library')"
      :confirm-button="{
        text: $t('document-templates.copy'),
        icon: 'mdi-content-copy'
      }"
      :selected.sync="selected"
      v-on:update:selected="updateSelected"
      :destinations="libraries"
      destination-label="document-templates.library"
      dispatch="documentTemplateStore/massCopy"
      :on-success="updateList"
    ></DialogForMassOperators>
    <DialogForMassOperators
      :dialog.sync="dialogDelete"
      :loading.sync="loading"
      :head-text="$t('document-templates.delete-title')"
      :content-text="$t('document-templates.delete-dialog')"
      :confirm-button="{
        text: $t('document-templates.delete'),
        icon: 'mdi-trash-can-outline'
      }"
      :selected.sync="selected"
      v-on:update:selected="updateSelected"
      dispatch="documentTemplateStore/deleteList"
      :on-success="updateList"
      permission="document_template.delete"
    ></DialogForMassOperators>
    <v-toolbar dense flat>
      <v-toolbar-title>{{
        $t("document-templates.document-templates")
      }}</v-toolbar-title>
      <v-toolbar-items>
        <v-btn text color="primary" :to="{ name: 'NewDocumentTemplate' }">
          <v-icon left>mdi-plus</v-icon>
          {{ $t("document-templates.add") }}
        </v-btn>
      </v-toolbar-items>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn
          v-for="item in menu"
          :key="item.title"
          :to="item.to"
          text
          color="primary"
          :disabled="item.disabled"
          v-on:click="item.onClick()"
          ><v-icon left>{{ item.icon }}</v-icon> {{ item.title }}</v-btn
        >
      </v-toolbar-items>
      <v-menu class="hidden-md-and-up">
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" color="primary" class="hidden-md-and-up">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item v-for="item in menu" :key="item.title + '-menu'" dense>
            <v-btn
              :to="item.to"
              text
              color="primary"
              :disabled="item.disabled"
              v-on:click="item.onClick()"
              ><v-icon left>{{ item.icon }}</v-icon> {{ item.title }}</v-btn
            >
          </v-list-item>
        </v-list>
      </v-menu>
    </v-toolbar>
    <v-divider></v-divider>
    <v-col class="py-0">
      <SearchDocument></SearchDocument>
    </v-col>
    <CommonTable
      list-getter="documentTemplateStore/getList"
      :headers="headers"
      :slots="slots"
      :actions="actions"
      resource="document-templates"
      @updated="updateList"
      :loading.sync="loading"
      create-item-dispatch="documentTemplateStore/create"
      delete-item-dispatch="documentTemplateStore/delete"
      show-select
      v-on:update:selected="updateSelected"
    ></CommonTable>
    <Paginator page-getter="documentTemplateStore/getPage"></Paginator>
  </v-col>
</template>

<script>
import Paginator from "../components/common/tables/Paginator";
import SearchDocument from "../components/common/tables/SearchDocument";
import CommonTable from "../components/common/tables/CommonTable";
import DialogForMassOperators from "../components/common/dialogs/DialogForMassOperators";
import { rules } from "../components/mixins/rules";
import { projectTitle } from "../components/mixins/projects/projectTitle";
import { permissions } from "../components/mixins/permissions";
export default {
  name: "DocumentTemplates",
  mixins: [rules, permissions, projectTitle],
  components: {
    Paginator,
    SearchDocument,
    CommonTable,
    DialogForMassOperators
  },
  data: function() {
    return {
      headers: [
        {
          text: this.$t("document-templates.name"),
          align: "left",
          value: "name"
        },
        {
          text: this.$t("document-templates.type"),
          value: "type_name"
        },
        {
          text: this.$t("document-templates.created_at"),
          value: "created_at"
        },
        {
          text: this.$t("document-templates.updated_at"),
          value: "updated_at"
        },
        {
          text: this.$t("document-templates.action"),
          value: "action",
          align: "right",
          sortable: false
        }
      ],

      actions: [
        {
          type: "delete",
          icon: "mdi-trash-can-outline",
          _permissions: "document_template.delete"
        }
      ],

      loading: false,
      dialogMove: false,
      dialogCopy: false,
      dialogDelete: false,
      selected: []
    };
  },
  computed: {
    getParams() {
      return ` ${this.$route.query.page}
                ${this.$route.query.limit_items}
                ${this.$route.query.orders}
                ${this.$route.query.search}
                ${this.$route.query.type}
                ${this.$route.query["template-library"]}
                `;
    },
    libraries() {
      return this.$store.getters["templateLibraryStore/getList"];
    },
    slots() {
      return [
        {
          name: "name",
          type: "link",
          to: "DocumentTemplate"
        },
        {
          name: "created_at",
          type: "date",
          human: true
        },
        {
          name: "updated_at",
          type: "date",
          human: true
        }
      ];
    },
    menu() {
      let vm = this;
      return [
        {
          title: this.$t("buttons.move"),
          to: null,
          onClick: function() {
            vm.dialogMove = true;
          },
          disabled: !this.isSomeSelectedCanBeMove,
          icon: "mdi-arrow-expand-right"
        },
        {
          title: this.$t("buttons.copy"),
          to: null,
          onClick: function() {
            vm.dialogCopy = true;
          },
          disabled: !this.isSomeSelectedCanBeCopy,
          icon: "mdi-content-copy"
        },
        {
          title: this.$t("buttons.delete"),
          to: null,
          onClick: function() {
            vm.dialogDelete = true;
          },
          disabled: !this.isSomeSelectedCanBeDelete,
          icon: "mdi-trash-can-outline"
        }
      ];
    },
    isSomeSelectedCanBeDelete() {
      return !!this.selected.find(i =>
        this.hasPermissions(i, "document_template.delete")
      );
    },
    isSomeSelectedCanBeMove() {
      return !!this.selected.find(i =>
        this.hasPermissions(i, "document_template.update")
      );
    },
    isSomeSelectedCanBeCopy() {
      return !!this.selected.length;
    }
  },

  watch: {
    getParams: function() {
      this.updateList();
    }
  },
  methods: {
    getArgumentForTitle() {
      return { chain: [this.$t("document-templates.document-templates")] };
    },
    updateList() {
      this.loading = true;
      let params = this.formingParams();
      this.$store.dispatch("documentTemplateStore/getList", {
        params,
        onSuccess: () => {
          this.loading = false;
        }
      });
    },
    formingParams() {
      return {
        project_id: this.project_id,
        page: this.$route.query.page,
        limit: this.$route.query.limit_items,
        orders: this.$route.query.orders,
        filters: {
          name: this.$route.query.search,
          document_type: this.$route.query.type,
          library: this.$route.query["template-library"]
        }
      };
    },
    updateSelected(val) {
      this.$set(this.$data, "selected", val);
    }
  },
  mounted() {
    this.updateList();
    this.$store.dispatch("documentTypeStore/getList", { limit: -1 });
  }
};
</script>

<style scoped>
.fullScreen {
  height: calc(100vh - 48px - 24px);
  display: flex;
  flex-direction: column;
}
.fullScreen::v-deep > * {
  flex: 0 0 auto;
}
.fullScreenMobile {
  height: auto;
  display: flex;
  flex-direction: column;
}
.get-lower {
  margin-top: 25px;
}
</style>
